
const ACCESS_TOKEN_KEY = import.meta.env.VITE_ACCESS_TOKEN_KEY;
const REFRESH_TOKEN_KEY = import.meta.env.VITE_REFRESH_TOKEN_KEY;
const AUTH_URL = import.meta.env.VITE_AUTH_URL;
const VITE_BASE_PATH = import.meta.env.VITE_BASE_PATH;


export const authService = {
  guestlogin: () => {
    const currentPort = window.location.port;
    const callbackUrl = encodeURIComponent(`${window.location.protocol}//${window.location.hostname}:${currentPort}${VITE_BASE_PATH}/authorize/callback`);
    window.location.href = `${AUTH_URL}/oauth/sso?return_url=${callbackUrl}`;
  },

  microsoftLogin: () => {
    const currentPort = window.location.port;
    const callbackUrl = encodeURIComponent(`${window.location.protocol}//${window.location.hostname}:${currentPort}${VITE_BASE_PATH}/authorize/callback`);
    window.location.href = `${AUTH_URL}/oauth/microsoft/login?return_url=${callbackUrl}`;
  },

  testLogin: () => {
    const currentPort = window.location.port;
    const callbackUrl = encodeURIComponent(`${window.location.protocol}//${window.location.hostname}:${currentPort}${VITE_BASE_PATH}/authorize/callback`);
    window.location.href = `${AUTH_URL}/oauth/test/login?return_url=${callbackUrl}`;
  },

  logout: () => {
    // Clear all auth-related storage
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem("authUserId");
    localStorage.removeItem("authEmail");
    localStorage.removeItem("userContext");
    sessionStorage.removeItem("userContext");
    sessionStorage.removeItem("authUserId");
    sessionStorage.removeItem("authEmail");
    
    // Redirect to login
    window.location.href = "/login";
  },

  getAccessToken: (): string | null => {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  },

  getRefreshToken: (): string | null => {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  },

  setTokens: (accessToken: string, refreshToken: string) => {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  },

  clearTokens: () => {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  },

  isAuthenticated: (): boolean => {
    return !!localStorage.getItem(ACCESS_TOKEN_KEY);
  },
};

export async function restoreSession(): Promise<string | null> {
    const refreshToken = authService.getRefreshToken();

    if (!refreshToken) {
        return null;
    }

    try {
        const response = await fetch(
            `${AUTH_URL}/user/refresh`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    token: refreshToken,
                }),
            }
        );

        if (!response.ok) {
            authService.clearTokens();
            return null;
        }

        const data = await response.json();

        authService.setTokens(
            data.access_token,
            refreshToken
        );

        console.log("✅ Previous session restored");

        return data.access_token;

    } catch (e) {

        console.error(e);

        authService.clearTokens();

        return null;
    }
}